'use strict';

const TrendingItems = require('bunsen/collections/identity/TrendingItems');
const {ACTIONS, STORE} = require('../constants/trendingConstants');
const User = require('../models/User');

// NOTE: Contract can be found in GROWTH-700
const trendingActions = {

    fetch(actionContext, payload, done) {
        const collection = new TrendingItems();
        const {
            type,
            categoryLevels,
            parentCategoryKey,
            query,
            pageSize = 1,
            collectionKey
        } = payload;

        collection
            .setParam('trendType', type)
            .setParam('categoryLevels', categoryLevels)
            .setParam('parentCategoryKey', parentCategoryKey)
            .setParam('userIds', User.getUserId())
            .setParam('query', query)
            .setParam('pageSize', pageSize);

        Promise.resolve(collection.fetchWithParameters())
            .then(() => {
                actionContext.dispatch(STORE.FETCH_SUCCESS, {collectionKey, collection});
                done();
            })
            .catch(() => {
                done();
            });
    },

    fetchByCategory(actionContext, payload, done) {
        const {categoryLevel = 3, itemsPageSize = 30, collectionKey, pageSize, fields} = payload;

        const fieldsQuery = fields ? `&fields=${fields}` : '';

        actionContext.executeAction(trendingActions.fetch, {
            type: ACTIONS.TYPE.CATEGORY,
            categoryLevels: categoryLevel,
            collectionKey,
            pageSize,
            query: `pageSize=${itemsPageSize}${fieldsQuery}&filterQuery=category_search:1,vertical:{vertical},l2_url_label:{l2_url_label},l3_url_label:{l3_url_label},l4_url_label:{l4_url_label}&sort=releasedate desc,sort_cs_status asc,priority asc`
        }).then(() => done());
    }
};

module.exports = trendingActions;



// WEBPACK FOOTER //
// ./assets/js/global/actions/trendingActions.es.js